// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__34Q5h","paramInput":"JobSimulator_paramInput__1zXcC","input":"JobSimulator_input__1TLGI"};